export default __webpack_public_path__ + "static/media/hauntedjaunt_demo_image.5eb6429a.png";